import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const OceanTag = ({ index, label }) => (
  <div className="flex items-center gap-3 mb-6" data-testid={`ocean-section-tag-${index}`}>
    <span className="h-px w-10 bg-ocoral" />
    <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-oreef">
      {index} / {label}
    </span>
  </div>
);

const STATUS_STYLES = {
  "PROPOSED": "text-oreef border-oreef/40 bg-oreef/10",
  "UNDER ASSESSMENT": "text-ogold border-ogold/40 bg-ogold/10",
  "CONFIRMED": "text-oseaglass border-oseaglass/40 bg-oseaglass/10",
  "IN DEVELOPMENT": "text-ogold border-ogold/40 bg-ogold/10",
  "PLANNED": "text-oslate border-oslate/40 bg-oslate/10",
};

export const StatusChip = ({ status }) => (
  <span
    className={`font-mono text-[9px] tracking-[0.22em] px-2.5 py-1 border ${STATUS_STYLES[status] || STATUS_STYLES.PLANNED}`}
    data-testid={`status-chip-${status.toLowerCase().replace(/\s+/g, "-")}`}
  >
    {status}
  </span>
);
